import { useAnonymousUserName } from "@bounce/store"

import type { Review } from "@/utils/reviews"

type UseReviewUsernameOptions = {
  review: Pick<Review, "user">
}

export const useReviewUsername = ({ review }: UseReviewUsernameOptions) => {
  const anonymous = useAnonymousUserName()

  return review.user.fullName || anonymous
}
